import SecureLS from 'secure-ls'
import Router from '../router';

//variables globales
var ls = new SecureLS({encodingType: 'aes'});

/**
 * Funcion para limpiar el localstorage y redireccionar a login cuando un servicio responde 401
 * Cuando se mande a llamar este método redireccionar a login con la siguiente linea
 * this.$router.push({ name: 'Login'});
 */
export function localStorageClean(){
    var data = ls.get('dUaStEaR');
    
    ls.clear();
    ls.set('dUaStEaR', data);

    
}

/**
 * Valida si existe un token, si no existe regresa un false, si existe regresa un true
 */
export function tokenExistValidate(){
    return new Promise ((resolve, reject) => {
        var token = ls.get('Token');
        if (token === undefined || token === '') {
            resolve(false);
        } else {
            resolve(true);            
        }
    });
}

/**
 * 
 * @param {*} numero  numero a formatear
 * @param {*} decimales cuantos decimales devuelve
 * @param {*} separadorDecimal deparador de decimales
 * @param {*} separadorMiles separador de miles
 */
export function numberFormat(numero, decimales, separadorDecimal, separadorMiles) {
    var partes, array;

    if ( !isFinite(numero) || isNaN(numero = parseFloat(numero)) ) {
        return "";
    }
    if (typeof separadorDecimal==="undefined") {
        separadorDecimal = ",";
    }
    if (typeof separadorMiles==="undefined") {
        separadorMiles = "";
    }
    // Redondeamos
    if ( !isNaN(parseInt(decimales)) ) {
        if (decimales >= 0) {
            numero = numero.toFixed(decimales);
        } else {
            numero = (
                Math.round(numero / Math.pow(10, Math.abs(decimales))) * Math.pow(10, Math.abs(decimales))
            ).toFixed();
        }
    } else {
        numero = numero.toString();
    }
    // Damos formato
    partes = numero.split(".", 2);
    array = partes[0].split("");
    for (var i=array.length-3; i>0 && array[i-1]!=="-"; i-=3) {
        array.splice(i, 0, separadorMiles);
    }
    numero = array.join("");

    if (partes.length>1) {
        numero += separadorDecimal + partes[1];
    }

    return numero;
}
//funcion que obtiene el hotel y codigo de grupo
export function separateText(inputText) {
    const atIndex = inputText.indexOf('@');
  
    if (atIndex !== -1) {
      const beforeAt = inputText.substring(0, atIndex);
      const afterAt = inputText.substring(atIndex + 1);
  
      return { beforeAt, afterAt };
    } else {
      // Handle the case when "@" is not present in the input text
      console.error('The "@" symbol is not present in the input text.');
      return null;
    }
}

//funcion que retorna una fecha en formato dd/mm/yyyy o mm/dd/yyyy dependiendo el lenguage es o en
export function convertBeautifulDate(uglyDate, language){
    const large = uglyDate + '';
    if (large.length > 10) {
        var date = new Date(uglyDate),
            mnth = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);
        if (language === 'es' || language === 'MXN') {
            return [day, mnth, date.getFullYear()].join("/");
        }
        if (language === 'en' || language === 'USD') {
            return [mnth, day, date.getFullYear()].join("/");
        }
    }
    if (large.length == 10) {
        return uglyDate;
    }
}

/*
retorna la versión del navegador
    Esta función retorna: 
        EDGE "version"
        IE "version"
        CHROME "version"
        OPERA "version"
        FIREFOX "version"
*/
export function  getBrowserInfo() {
    var ua= navigator.userAgent, tem, 
    M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if(/trident/i.test(M[1])){
        tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
        return 'IE '+(tem[1] || '');
    }
    if(M[1]=== 'Chrome'){
        tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
        if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
    }
    M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
    if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
    return M.join(' ');
};

//funcion que retorna si la fecha de expiracion de una tarjeta de credito es valida
export function IsValidDateExpiration(mes, ano){
    var respuesta = {
        banDate: null,
        tipoError: null
    };
    /**
     * tipoError
     * 2: fecha expirada
     * 1: año invalido
     * 0: valido
     */
    //var banDate = false;
    var date = new Date();
    var mesActual = date.getMonth() + 1;
    var anoActual = date.getFullYear();
    if (ano > anoActual + 10) {
        respuesta.banDate = true;
        respuesta.tipoError = 1;
    } else {
        if (ano > anoActual && ano <= anoActual + 10) {
            respuesta.banDate = false;
            respuesta.tipoError = 0;
        } else{
            if (ano == anoActual && mes >= mesActual) {
                respuesta.banDate = false;
                respuesta.tipoError = 0;
            } else {
                respuesta.banDate = true;
                respuesta.tipoError = 2;
            }
        }
    }
    return respuesta;
}

//funcion que limpia el localStorage al termino de una reserva, copia o modificacion (agregar las que se vayan creando)
export function cleanLocalStorageOfReserva(){
    ls.remove("InfoGrupo");
    ls.remove("brandCodeForWs");
    ls.remove("brandNameForWs");
    ls.remove("hotelConfiguration");
    ls.remove("何");
    ls.remove("何女");
    ls.remove("availibilityRequest");
    ls.remove("BusquedaPorTarifaInfo");
    ls.remove("specialMessageR");
    ls.remove("contractCodesLangProblem");
    ls.remove("mesContractCodesForReservation");
    ls.remove("brandCodeForReservationService");
    ls.remove("DetailHotelInfo");
    ls.remove("choosingEditing");
    ls.remove("isCopy");
    ls.remove("hotelMailImage");
    ls.remove("rateDesEr");
    ls.remove("nuitsPourS");
    ls.remove("updateCostDetail");
    ls.remove("blocklanguages");
    ls.remove("datosHabHotSelected");
    ls.remove("rateTypeForReservationRequest");
    ls.remove("changeTitleMod");
    ls.remove("supplement");
    ls.remove("jobPhonesForReservationRequest");
    ls.remove("dataPersonalH1");
    ls.remove("dataPersonalH2");
    ls.remove("dataPersonalH3");
    ls.remove("dataPersonalH4");
    ls.remove("dataPersonalH5");
    ls.remove("contactDataH1");
    ls.remove("contactDataH1");
    ls.remove("contactDataH1");
    ls.remove("contactDataH1");
    ls.remove("contactDataH1");
    ls.remove("contactDataH1");
    ls.remove("requirementsDataH1");
    ls.remove("requirementsDataH2");
    ls.remove("requirementsDataH3");
    ls.remove("requirementsDataH4");
    ls.remove("requirementsDataH5");
    ls.remove("fixA");
    ls.remove("supplDeta");
    ls.remove("supleCondiOneFirstNight");
    ls.remove("supleCondi");
    ls.remove("metodosPagoData");
    ls.remove("responseReservation");
    ls.remove("descriptionMS");
    ls.remove("opSuE");
    ls.remove("HotelCard");
    ls.remove("requeriment");
   // ls.remove("hotelInfo");       NO DESCOMENTAR, INGRESAR ESTA ACCIÓN GENERÓ EL JIRA 821. COMETANDO ESTA LINEA SE RESUELVO EL JIRA PERO AÚN ESTA EN FASE DE REPORTAR FUTUROS BUGS.
    ls.remove("knowOrigin");
    ls.remove("roomNameSW");
    ls.remove("noConForRm");
    ls.remove("codeReservation");
    ls.remove("extraDetailS");
    ls.remove("clearHome");
    ls.remove("rateNameDiscountCode");
    ls.remove("hotelReservationByCodeModd");
    ls.remove("iataL");
    ls.remove("emailManquant");
    ls.remove("hotelCodeROWS");
    ls.remove("contractCodeROWS");
    ls.remove("motivaNumber");
    ls.remove("motivaReadOnly");
    ls.remove("dailyRate");
    ls.remove("totalCostWithTaxesF");
    ls.remove("hotelNameReadOnly");
    ls.remove("typeNameRO");
    ls.remove("arrivalDateReadOnly");
    ls.remove("departureDateReadOnly");
    ls.remove("nightsReadOnly");
    ls.remove("totalRoomsReadOnly");
    ls.remove("totalGuestsReadOnly");
    ls.remove("discountCodeRO");
    ls.remove("promoCodeRO");
    ls.remove("nameReadOnly");
    ls.remove("companionReadOnly");
    ls.remove("roomNameRO");
    ls.remove("contractTypeRO");
    ls.remove("totalStayRO");
    ls.remove("paymentMethodRO");
    ls.remove("extradateOutput");
    ls.remove("hotelDetailModd");
    ls.remove("fromCopy");
    ls.remove("CopyReservation");
    ls.remove("reservationRequestEdition");
    ls.remove("preTe");
    ls.remove("dernierDM");
    ls.remove("arrivalForm");
    ls.remove("departureForm");
    ls.remove("disModDa");
    ls.remove("unableApreciare");
    ls.remove("HotelDetailDataPoliticas");
    ls.remove("opSuEList");
    ls.remove("CompanyDataH1");
}

/**
 * 
 * @param {*} textValidar 
 * Función que limpia los caracteres expeciales no permitidos de un texto ingresado
 */
export function validText1(textValidar){
    return textValidar.replace(/[^a-zA-Z0-9-_ ñ´]/g, '');
}

export function validText2(textValidar){
    return textValidar.replace(/[^a-zA-Z0-9 ñ!¡"#$%&/()=¿?´¨*+~;,:._-]/g, '');
}

export function validNumEmpleado(textValidar){
    return textValidar.replace(/[^a-zA-Z0-9-_]/g, '');
}

export function validIfGenericUser(){
    if (ls.get('isUserGeneric') != undefined && ls.get('isUserGeneric') != null && ls.get('isUserGeneric') != '') {
        if (ls.get('isUserGeneric').data) {
            Router.push({ name: "Reservaciones" });
            return ls.get('isUserGeneric').data;
        }
    } else {
        setTimeout(() => {
            validIfGenericUser();
        }, 500);
    }
}


//KB47296 Start
export function validatePhoneNumber(areaCodeSelected, phoneNumber, phoneType){
    //console.log("<<< =============== >>>");
    let response = '';
    if(phoneNumber){

        if(phoneNumber.startsWith("+")){
            response = phoneNumber;
        }else{
            response = areaCodeSelected + phoneNumber;
        }
        
        //console.log(areaCodeSelected)
        //console.log(phoneNumber)
        //console.log(phoneType)
        if(areaCodeSelected === '+52' && phoneType === 'MOB' && !phoneNumber.startsWith("1")){ //It's a MX number
            

            if(phoneNumber.startsWith("+")){
                response = phoneNumber;
            }else{
                response = areaCodeSelected + "1" +phoneNumber;
            }

        }
    }
    
    //console.log(response);
    //console.log("<<< =============== >>>");

    return response;
}
//KB47296 End